import { AbstractControl, FormArray, FormControl, FormGroup, FormRecord, Validators } from '@angular/forms';

import { EmailAddressForm } from '@forms/email-address-form';
import { EmailAttachmentForm } from '@forms/email-attachment-form';
import { ContractEmailAttachmentForm } from '@gi/forms/contract-email-attachment-form';
import { FormHelper } from '@helpers/form.helper';
import { ErrorMessage } from '@interfaces/error-message';

type EmailFormType = {
  from: FormControl<string>;
  to: FormArray<EmailAddressForm>;
  cc: FormArray<EmailAddressForm>;
  cci: FormArray<EmailAddressForm>;
  subject: FormControl<string>;
  body: FormControl<string | null>;
  attachments: FormArray<EmailAttachmentForm | ContractEmailAttachmentForm>;
  emailFields: FormRecord;
  replyTo: FormControl<string | null>;
};

export class EmailFormBase<
  TControl extends {
    [K in keyof TControl]?: AbstractControl<any>;
  } = any
> extends FormGroup<TControl & EmailFormType> {
  get from(): FormControl<string> {
    return this.controls.from as FormControl<string>;
  }

  get to(): FormArray<EmailAddressForm> {
    return this.controls.to as FormArray<EmailAddressForm>;
  }

  get toErrorMessage(): ErrorMessage | null {
    return FormHelper.getEmptyErrorMessage(this.to, 'Le destinataire est requis', 'Destinataire incorrect');
  }

  get cc(): FormArray<EmailAddressForm> {
    return this.controls.cc as FormArray<EmailAddressForm>;
  }

  get cci(): FormArray<EmailAddressForm> {
    return this.controls.cci as FormArray<EmailAddressForm>;
  }

  get subject(): FormControl<string> {
    return this.controls.subject as FormControl<string>;
  }

  get subjectErrorMessage(): ErrorMessage | null {
    return FormHelper.getEmptyErrorMessage(this.subject, 'Le sujet est requis', 'Sujet incorrect');
  }

  get body(): FormControl<string | null> {
    return this.controls.body as FormControl<string | null>;
  }

  get bodyErrorMessage(): ErrorMessage | null {
    return FormHelper.getEmptyErrorMessage(this.body, 'Le message est requis', 'Message incorrect');
  }

  get attachments(): FormArray<EmailAttachmentForm | ContractEmailAttachmentForm> {
    return this.controls.attachments as FormArray<EmailAttachmentForm | ContractEmailAttachmentForm>;
  }

  get replyTo(): FormControl<string | null> {
    return this.controls.replyTo as FormControl<string | null>;
  }

  constructor(additionalControls: TControl = {} as TControl) {
    super({
      from: new FormControl<string>('', Validators.required),
      to: new FormArray<EmailAddressForm>([], Validators.required),
      cc: new FormArray<EmailAddressForm>([]),
      cci: new FormArray<EmailAddressForm>([]),
      subject: new FormControl('', Validators.required),
      body: new FormControl(null, Validators.required),
      attachments: new FormArray<EmailAttachmentForm | ContractEmailAttachmentForm>([]),
      emailFields: new FormRecord({}),
      replyTo: new FormControl<string | null>(null),
      ...additionalControls
    } as TControl & EmailFormType);
  }
}
